import { LiveSource } from './types'

import { CreatedFrom } from 'modules/transmission/types'

export const LIVE_SOURCE_BY_CREATED_FROM: { [createdFrom in CreatedFrom]: LiveSource} = {
  [CreatedFrom.CLUB]: LiveSource.Club,
  [CreatedFrom.ONLINE_EVENT]: LiveSource.OnlineEvent,
  [CreatedFrom.ON_FIRE]: LiveSource.OnlineEvent,
  [CreatedFrom.SPARKLE]: LiveSource.Sparkle,
  [CreatedFrom.WEBINAR]: LiveSource.Webinar
}
